/* eslint-disable no-lonely-if */
/* eslint-disable no-lonely-if */
import viewTransitionNavUtility from "./viewTransitionNavUtility";
import {
  addLanguageToPath,
  isChinaDomainClient,
  getLanguagePreference,
  saveLanguagePreference,
} from "./languageCore";

const customHistoryPush = (history: any, link: string, noTransition = false) => {
  const { appData }: any = window.__INITIAL_STATE__;
  let userLanguage = appData?.userLanguage || "en";

  if (!userLanguage || userLanguage === "en") {
    const storedLanguage = getLanguagePreference();
    if (storedLanguage) userLanguage = storedLanguage;
  }

  saveLanguagePreference(userLanguage);

  // Check if this is China domain - skip language prefix for China
  const isChinaDomain = isChinaDomainClient();

  // For China domain, never add language prefix (Chinese is default)
  const enhancedLink = isChinaDomain ? link : addLanguageToPath(link, userLanguage);

  if (appData.isDesktop && appData.isInternalUser) {
    window.location.href = enhancedLink;
  } else {
    if (noTransition) history.push(enhancedLink);
    else viewTransitionNavUtility(() => history.push(enhancedLink), "right-to-left");
  }
};

export default customHistoryPush;
